import { render } from "./FeatureOrganizations.vue?vue&type=template&id=471613a2&scoped=true"
import script from "./FeatureOrganizations.vue?vue&type=script&lang=js"
export * from "./FeatureOrganizations.vue?vue&type=script&lang=js"

import "./FeatureOrganizations.vue?vue&type=style&index=0&id=471613a2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471613a2"]])

export default __exports__